import { render, staticRenderFns } from "./aliBey.vue?vue&type=template&id=e376041e&scoped=true"
import script from "./aliBey.vue?vue&type=script&lang=js"
export * from "./aliBey.vue?vue&type=script&lang=js"
import style0 from "./aliBey.vue?vue&type=style&index=0&id=e376041e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e376041e",
  null
  
)

export default component.exports